import { FC } from 'react';
import classNames from 'classnames';

import { icon_chevron_left, icon_chevron_right } from '@gn-audio/icons';
import { JabraIcon, useFallbackTranslation } from '@gn-audio/jss-components';

import { CategoryPromoSpotSliderButtonProps } from './categoryPromoSpotTypes';

const CategoryPromoSpotSliderButton: FC<CategoryPromoSpotSliderButtonProps> = ({
  direction,
  onClick,
  disabled,
}) => {
  const { t } = useFallbackTranslation();
  const ariaLabel = direction === 'left' ? t('system.Previous') : t('system.Next');
  const icon = direction === 'left' ? icon_chevron_left : icon_chevron_right;
  const buttonAlignmentClass =
    direction === 'left' ? 'ml-2 xl:ml-0 left-0' : ' mr-2 xl:mr-0 right-0';
  const butotnDisabledClass = disabled ? 'opacity-50' : 'hover:h-24 hover:bg-[rgba(42,63,89,0.9)]';

  return (
    <button
      className={classNames(
        `absolute top-1/2 z-10 mr-2 flex h-20 w-16 -translate-y-1/2 transform items-center justify-center rounded-full bg-[#2A3F59] text-white transition-all duration-300`,
        buttonAlignmentClass,
        butotnDisabledClass
      )}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <JabraIcon iconStyle={{ strokeWidth: 2 }} Icon={icon} />
    </button>
  );
};

export default CategoryPromoSpotSliderButton;
